import { create } from 'zustand';

/**
 * Shared open/close state for the mobile left-hand navigation drawer.
 * The opener (hamburger in the Header) and the drawer itself (rendered by
 * Navigation) are sibling components, so they coordinate through this store.
 */
interface NavDrawerState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

export const useNavDrawer = create<NavDrawerState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  toggle: () => set((s) => ({ isOpen: !s.isOpen })),
}));
